import Container from './AddCommentButton';
export default Container;

export const componentName = 'AddCommentButton';
